import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import CopyValue from "./CopyValue";

const ShortSid = observer((props) => {
    const [allowCopy, setAllowCopy] = useState(false);

    useEffect(() => {
    
        if(!props.hasOwnProperty("allowCopy")){
            setAllowCopy(true);
        }   
    
        // eslint-disable-next-line
      }, []);


   
    
    const formatString = (str) => {
        if(str){
            if (str.length <= 8) {
                return str;
            }
            return `${str.slice(0, 4)} ... ${str.slice(-4)}`;        
        }else{
            return "";
        }
      };

      const formattedString = formatString(props.sid);
      
      return (
        <>
          {formattedString}
          {!allowCopy ? (<>d</>) : (<CopyValue text={props.sid} />)}
        </>
      );

  });
  
  export default ShortSid;
  